module.exports = __webpack_public_path__ + "static/apple-touch-icon-6e2846f7b46d77218d8d0bd4ae44d9a6.png";